import { PassOrFail, PayablePaymentStatusEnum, PlantsEnum, SubPlantCodesEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn, Generated } from "typeorm";
import { GrnItems } from "./raw-material-grn-items.entity";
import { CompanyTypeEnum, InvoiceStatusEnum } from "@gtpl/shared-models/masters";
@Entity('grn')
export class Grn {

    @PrimaryGeneratedColumn("increment", { name: 'grn_id' })
    grnId: number;
    @Column({
        nullable: false,
        name: "grn_date"
    })
    grnDate: Date;

    @Column({
        type: 'int',
        nullable: true,
        // default: 0,
        name: 'plant_id'
    })
    plantId: number;

    @Column({
        type: 'int',
        nullable: true,
        // default: 0,
        name: 'sub_plant_id'
    })
    subPlantId: number;

    // @Column({
    //     type: 'enum',
    //     enum: SubPlantCodesEnum,
    //     nullable: true,
    //     // default: SubPlantCodesEnum.KDM,
    //     name: 'sub_plant_id'
    // })
    // subPlantId: SubPlantCodesEnum;

    @Column("int", {
        nullable: false,
        name: "indent_no"
    })
    indentId: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "grn_number"
    })
    grnNumber: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "voucher_number"
    })
    voucherNumber: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "supplier_type"
    })
    supplierType: string;

    // @Column("varchar", {
    //     nullable: true,
    //     length: 50,
    //     name: "inv_no"
    // })
    // invoiceNumber: string;

    // @Column({
    //     nullable: true,
    //     name: "inv_date"
    // })
    // invoiceDate: Date;

    @Column("enum", {
        nullable: true,
        name: "inv_status",
        enum:InvoiceStatusEnum,
        default:InvoiceStatusEnum.OPEN
    })
    invoiceStatus: InvoiceStatusEnum;

    // @Column('int',{
    //     nullable: true,
    //     name: "bill_to"
    // })
    // billTo: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;


    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    // @Column("varchar", {
    //     nullable: true,
    //     length: 30,
    //     name: "batch_number"
    // })
    // batchNumber: string;

    @Column('enum',{
        nullable: true,
        name: "reweighment_bill_to",
        enum:CompanyTypeEnum
    })
    reweighmentBillTo: CompanyTypeEnum;

    @Column('varchar',{
        nullable: true,
        name: "vehicle_number",
        length:50
    })
    vehicleNumber: string;

    @Column('varchar',{
        nullable: true,
        name: "seal_number",
        length:50
    })
    sealNumber: string;

    @Column({
        nullable: true,
        name: "reweighment_date",
    })
    reweighmentDate: Date;

    @Column('int',{
        nullable: true,
        name: "supervisor_id",
    })
    supervisor: number;

     @Column("varchar", {
            nullable: true,
            length: 50,
            name: "test_result"
        })
        testResult: PassOrFail;

    // @Column('int',{
    //     name:'ref_no'
    // })
    // refNumber : number
    @Column({
        type: 'enum',
        enum: PayablePaymentStatusEnum,
        nullable: true,
        // default: SubPlantCodesEnum.KDM,
        name: 'payment_status'
    })
    paymentStatus: PayablePaymentStatusEnum;

    @Column("int", {
        nullable: true,
        name: "ref"
    })
    refNo: number;

        @Column("boolean", {
        nullable: false,
        default: false,
        name: "is_po_created"
    })
    isPoCreated: boolean;

        @Column("varchar", {
        nullable: false,
        length: 30,
        name: "invoice_number"
    })
    invoiceNo: string;

        @Column({
        nullable: true,
        name: "invoice_date",
    })
    invoiceDate: Date;

        @Column("int", {
        nullable: true,
        name: "inv_ref_no"
    })
    invRefNo: number;

            @Column("varchar", {
        nullable: false,
        length: 30,
        name: "financial_year"
    })
    financialYear: string;


    @OneToMany(type => GrnItems, grnItems => grnItems.grnInfo, { cascade: true })
    grnItemsInfo: GrnItems[];
}
